<template>
  <div :class="$style.progress">
    <div
      v-if="$screen !== 's'"
      :class="$style.innerProgress"
    >
      <BaseProgress
        :percentage="
          Math.min(
            100,
            Math.round((reviewsPublished / 50) * 100)
          )
        "
        v-test="'feedback-count'"
      />
    </div>
    <BaseText>
      {{ reviewsPublished <= 50
          ? $t(
              'admin.treatwell.main.getting_evaluated.reviews_published',
              { count: reviewsPublished }
            )
          : $t(
              'admin.treatwell.main.getting_evaluated.reviews_completed'
            ) }}
    </BaseText>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useQuery } from '@vue/apollo-composable';
import { computed } from 'vue';
import { useLocationsStore } from '@/stores/locations';
import { GET_FEEDBACK_COUNT } from '../graphql';

// How far the salon is towards the 50 published reviews the marketplace looks for
const { locationId, dataScope } = useLocationsStore();

const { result: feedbackCount } = useQuery(GET_FEEDBACK_COUNT, {
  locationId,
  dataScope,
});

const reviewsPublished = computed(
  () => feedbackCount.value?.feedbackCount?.total || 0,
);
</script>

<style
  lang="scss"
  module
>
.progress {
  display: flex;
  align-items: center;
  gap: $spacing;
}

.innerProgress {
  min-width: 60px;
}
</style>
